// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1186":"22eb790f","1704":"0edf2054","4485":"4e489f7b","6243":"626a9a7d"}[chunkId] + ".chunk.css";
};